const visitFitStudioPaperConstants = {
    tableSize: 40,
  };
  
  export default visitFitStudioPaperConstants;